export enum ConsentStatuses {
  defaultAccept= 'default_accept',
  defaultReject = 'default_reject',
  managed = 'managed'
}
